import extend from 'extend';
import Q from 'q';
import _ from 'underscore';

import consumer_payment_getPayChannel
    from '../../../../../lib/data-service/haolv-default/consumer_payment_getPayChannel';
import consumer_payment_toPay from '../../../../../lib/data-service/haolv-default/consumer_payment_toPay';
import consumer_payment_notifyPoll from '../../../../../lib/data-service/haolv-default/consumer_payment_notifyPoll';

import BasePaymentMethodSelector from '../component/base-payment-method-selector/index.vue';

export default {
    components: {
        BasePaymentMethodSelector,
    },
    props: {},
    data() {
        return {}
    },
    methods: {
        init(pInitParameter) {
            const __this = this;
            if (!pInitParameter) pInitParameter = {};
            if (!pInitParameter.btn_pay) pInitParameter.btn_pay = {};
            if (!pInitParameter.ui_show) pInitParameter.ui_show = {};

            const btn_pay_text = pInitParameter.btn_pay.text;
            const ui_show_is_show_header_container_amount_to_be_paid = pInitParameter.ui_show.is_show_header_container_amount_to_be_paid;

            const get_params = pInitParameter.get_params;
            const before_pay_event_handler = pInitParameter.before_pay_event_handler;
            const pay_successful_event_handler = pInitParameter.pay_successful_event_handler;
            const pay_failed_event_handler = pInitParameter.pay_failed_event_handler;

            __this.$refs.aBasePaymentMethodSelector.init({
                btn_pay: {
                    text: btn_pay_text,
                },

                count_down: {
                    enable: false,//是否启用倒计时，默认值为false
                    pay_remaining_seconds: 60 * 60 * 1,//支付剩余时间，以秒为单位
                },

                ui_show: {
                    is_show_header_container_amount_to_be_paid: ui_show_is_show_header_container_amount_to_be_paid,
                },

                //在这里传入订单详情的相关参数
                get_params,

                //在这里调用获取支付方式的接口
                get_payment_channel_entity_list(args) {
                    const __this__ = args.__this;
                    const companyId = __this__.data_get_params.companyId;
                    const isUseCredit = __this__.data_get_params.isUseCredit;
                    const orderAmount = __this__.data_get_params.orderAmount;

                    return Q.when()
                        .then(function () {
                            return consumer_payment_getPayChannel({
                                companyId: companyId,
                                isUseCredit: isUseCredit,
                                payAmount: orderAmount,
                                type: 2,
                            });
                        })
                        .then(function (data) {
                            const datas = data.datas;
                            const payment_channel_entity_list = datas;
                            return Q.resolve({
                                payment_channel_entity_list,
                                data_get_payment_channel_entity_list: data,
                            });
                        })
                        ;
                },

                //在这里调用支付的接口
                pay(args) {
                    const __this__ = args.__this;
                    const selected_payment_channel_entity_list = args.selected_payment_channel_entity_list;
                    const password = args.password;

                    const paymentChannelVos = _.chain(selected_payment_channel_entity_list)
                        .map(function (m) {
                            const payment_amount_number = m.payment_amount_number;
                            const code = m.code;
                            const o = {};
                            o.amount = payment_amount_number;
                            o.paymentChannel = code;
                            return o;
                        })
                        .value()
                    ;

                    return Q.when()
                        .then(function () {
                            const companyId = __this__.data_get_params.companyId;
                            const clubId = __this__.data_get_params.clubId;
                            const orderNo = __this__.data_get_params.orderNo;
                            const businessContent = __this__.data_get_params.businessContent;
                            const subject = __this__.data_get_params.subject;

                            return consumer_payment_toPay({
                                companyId: companyId,
                                clubId: clubId,
                                orderNo: orderNo,
                                businessContent: businessContent,
                                subject: subject,
                                paymentChannelVos: paymentChannelVos,
                                password: password,
                            });
                        })
                        .then(function (data) {
                            return Q.resolve({
                                data_pay: data,
                            });
                        })
                        ;
                },

                //在这里调用检查支付状态的接口（不用实现轮询逻辑，轮询逻辑由内部实现）
                check_payment_status(args) {
                    const __this__ = args.__this;
                    const tradeNo = args.tradeNo;
                    return Q.when()
                        .then(function () {
                            return consumer_payment_notifyPoll({
                                outTradeNo: tradeNo,
                            });
                        })
                        .then(function (data) {
                            return Q.resolve({
                                data_check_payment_status: data,
                            });
                        })
                        ;
                },

                //支付操作前的事件处理方法，常用于验证是否能够进行支付操作
                before_pay_event_handler,

                //支付成功事件处理方法
                pay_successful_event_handler,

                //支付失败事件处理方法
                pay_failed_event_handler,
            });
        },
    },
    created() {
    },
}
